// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CountrySelect Component Styles */

.scl--web-component-country-select-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  padding-bottom: 20px;
  width: 100%;
  flex: none;
  order: 0;
  flex-grow: 0;
  position: relative;
}

.scl--web-component-country-select-input-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 52px;
  border: 1px solid #7D8187;
  border-radius: 2px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
  padding: 0;
  text-align: left;
}

.scl--web-component-country-select-input-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  background: #84A578;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--web-component-country-select-input-plate.open::after {
  opacity: 1;
}

.scl--web-component-country-select-input-plate:hover:not(.open) {
  border-color: #9EA0A4;
}

.scl--web-component-country-select-input-plate.open {
  border-color: #9EA0A4;
}

.scl--web-component-country-select-input-plate.error::after {
  background: #F8868A;
  opacity: 1;
}

.scl--web-component-country-select-input-plate.warning::after {
  background: #FFC18E;
  opacity: 1;
}

.scl--web-component-country-select-input-plate.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--web-component-country-select-input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 20px;
  gap: 12px;
  width: 100%;
  height: 52px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--web-component-country-select-value-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  height: 100%;
  width: 100%;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--web-component-country-select-text-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

.scl--web-component-country-select-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-family: var(--primary-font);
  font-style: light;
  font-weight: 274;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.50px;
  color: #FFFFFF;
}

.scl--web-component-country-select-selected-flag {
  width: 20px;
  height: 16px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--web-component-country-select-selected-flag img {
  width: 20px;
  height: auto;
  object-fit: contain;
}

.scl--web-component-country-select-dial-code {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 16px;
  line-height: 20px;
  color: #FFFFFF;
}

.scl--web-component-country-select-chevron-icon {
  width: 16px;
  height: 16px;
  flex: none;
  flex-grow: 0;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.scl--web-component-country-select-chevron-icon path {
  stroke: #7D8187;
  transition: stroke 0.3s ease;
}

.scl--web-component-country-select-input-plate:hover .scl--web-component-country-select-chevron-icon path,
.scl--web-component-country-select-input-plate.open .scl--web-component-country-select-chevron-icon path {
  stroke: #FFFFFF;
}

.scl--web-component-country-select-input-plate.open .scl--web-component-country-select-chevron-icon {
  transform: rotate(180deg);
}

/* ✅ Floating Label Styles - Always visible, animates position */
.scl--web-component-country-select-label {
  position: absolute;
  left: 21px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #7D8187;
  background: transparent;
  padding: 0 4px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1;
  opacity: 1;
}

/* ✅ Floating state - label moves to top */
.scl--web-component-country-select-label.floating {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

/* ✅ Hover effect on label */
.scl--web-component-country-select-input-plate:hover:not(.open) .scl--web-component-country-select-label {
  color: #C9CACD;
}

.scl--web-component-country-select-input-plate:hover:not(.open) .scl--web-component-country-select-label .scl--web-component-country-select-required-asterisk {
  color: #EB5252;
}

/* Required Asterisk Styles */
.scl--web-component-country-select-required-asterisk {
  color: #EB5252;
}

/* Dropdown Styles */
.scl--web-component-country-select-dropdown {
  position: absolute;
  top: calc(100% + -12px);
  left: 0;
  width: auto;
  background: #000000;
  border-radius: 2px;
  max-height: 0;
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  opacity: 0;
  transform: translateY(-10px);
  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0.3s;
  pointer-events: none;
  visibility: hidden;
}

.scl--web-component-country-select-dropdown.open {
  max-height: 211px;
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
  visibility: visible;
  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0s;
}

.scl--web-component-country-select-search {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 4px;
  gap: 14px;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  flex: none;
  order: 0;
  flex-grow: 0;
}

.scl--web-component-country-select-search-icon {
  width: 16px;
  height: 13px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.scl--web-component-country-select-search-icon path {
  stroke: #7D8187;
}

.scl--web-component-country-select-search-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  padding: 0;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--web-component-country-select-search-input::placeholder {
  color: #7D8187;
}

.scl--web-component-country-select-options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 0;
  gap: 6px;
  max-height: 175px;
  overflow-y: auto;
  transition: all 0.3s ease;
}

.scl--web-component-country-select-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;
  gap: 10px;
  width: 100%;
  height: 38px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  flex: none;
  flex-grow: 0;
  background: transparent;
  border: none;
  text-align: left;
}

.scl--web-component-country-select-option:hover {
  background-color: rgba(125, 129, 135, 0.1);
}

.scl--web-component-country-select-option.selected {
  background-color: rgba(125, 129, 135, 0.2);
}

.scl--web-component-country-select-option-flag {
  width: 20px;
  height: 16px;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--web-component-country-select-option-flag img {
  width: 20px;
  height: auto;
  object-fit: contain;
}

.scl--web-component-country-select-option-label {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #7D8187;
  flex: 1;
  order: 1;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scl--web-component-country-select-no-options {
  padding: 12px 10px;
  font-family: var(--primary-font);
  font-size: 12px;
  color: #7D8187;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

/* Custom scrollbar for dropdown */
.scl--web-component-country-select-options::-webkit-scrollbar {
  width: 4px;
}

.scl--web-component-country-select-options::-webkit-scrollbar-track {
  background: #393939;
}

.scl--web-component-country-select-options::-webkit-scrollbar-thumb {
  background: #1C1C1C;
  border-radius: 0px;
}

.scl--web-component-country-select-options::-webkit-scrollbar-thumb:hover {
  background: #7D8187;
}

/* Error Text */
.scl--web-component-country-select-error-text {
  position: absolute;
  bottom: 0;
  left: 0;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #FF5252;
  padding-left: 14px;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/input/phone-number/css/countrySelect.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,WAAW;EACX,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,iGAAiG;EACjG,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,+FAA+F;AACjG;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* CountrySelect Component Styles */\n\n.scl--web-component-country-select-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  padding-bottom: 20px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  position: relative;\n}\n\n.scl--web-component-country-select-input-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 52px;\n  border: 1px solid #7D8187;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n  padding: 0;\n  text-align: left;\n}\n\n.scl--web-component-country-select-input-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  background: #84A578;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--web-component-country-select-input-plate.open::after {\n  opacity: 1;\n}\n\n.scl--web-component-country-select-input-plate:hover:not(.open) {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-country-select-input-plate.open {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-country-select-input-plate.error::after {\n  background: #F8868A;\n  opacity: 1;\n}\n\n.scl--web-component-country-select-input-plate.warning::after {\n  background: #FFC18E;\n  opacity: 1;\n}\n\n.scl--web-component-country-select-input-plate.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--web-component-country-select-input-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 20px;\n  gap: 12px;\n  width: 100%;\n  height: 52px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--web-component-country-select-value-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--web-component-country-select-text-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.scl--web-component-country-select-text {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--primary-font);\n  font-style: light;\n  font-weight: 274;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  color: #FFFFFF;\n}\n\n.scl--web-component-country-select-selected-flag {\n  width: 20px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--web-component-country-select-selected-flag img {\n  width: 20px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--web-component-country-select-dial-code {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 16px;\n  line-height: 20px;\n  color: #FFFFFF;\n}\n\n.scl--web-component-country-select-chevron-icon {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n.scl--web-component-country-select-chevron-icon path {\n  stroke: #7D8187;\n  transition: stroke 0.3s ease;\n}\n\n.scl--web-component-country-select-input-plate:hover .scl--web-component-country-select-chevron-icon path,\n.scl--web-component-country-select-input-plate.open .scl--web-component-country-select-chevron-icon path {\n  stroke: #FFFFFF;\n}\n\n.scl--web-component-country-select-input-plate.open .scl--web-component-country-select-chevron-icon {\n  transform: rotate(180deg);\n}\n\n/* ✅ Floating Label Styles - Always visible, animates position */\n.scl--web-component-country-select-label {\n  position: absolute;\n  left: 21px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: #7D8187;\n  background: transparent;\n  padding: 0 4px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* ✅ Floating state - label moves to top */\n.scl--web-component-country-select-label.floating {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n/* ✅ Hover effect on label */\n.scl--web-component-country-select-input-plate:hover:not(.open) .scl--web-component-country-select-label {\n  color: #C9CACD;\n}\n\n.scl--web-component-country-select-input-plate:hover:not(.open) .scl--web-component-country-select-label .scl--web-component-country-select-required-asterisk {\n  color: #EB5252;\n}\n\n/* Required Asterisk Styles */\n.scl--web-component-country-select-required-asterisk {\n  color: #EB5252;\n}\n\n/* Dropdown Styles */\n.scl--web-component-country-select-dropdown {\n  position: absolute;\n  top: calc(100% + -12px);\n  left: 0;\n  width: auto;\n  background: #000000;\n  border-radius: 2px;\n  max-height: 0;\n  overflow: hidden;\n  z-index: 1000;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0.3s;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.scl--web-component-country-select-dropdown.open {\n  max-height: 211px;\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n  visibility: visible;\n  transition: max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease, visibility 0s ease 0s;\n}\n\n.scl--web-component-country-select-search {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 4px;\n  gap: 14px;\n  width: 100%;\n  height: 30px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.scl--web-component-country-select-search-icon {\n  width: 16px;\n  height: 13px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.scl--web-component-country-select-search-icon path {\n  stroke: #7D8187;\n}\n\n.scl--web-component-country-select-search-input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 12px;\n  line-height: 14px;\n  color: #FFFFFF;\n  padding: 0;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--web-component-country-select-search-input::placeholder {\n  color: #7D8187;\n}\n\n.scl--web-component-country-select-options {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 8px 0;\n  gap: 6px;\n  max-height: 175px;\n  overflow-y: auto;\n  transition: all 0.3s ease;\n}\n\n.scl--web-component-country-select-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 10px;\n  gap: 10px;\n  width: 100%;\n  height: 38px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  box-sizing: border-box;\n  flex: none;\n  flex-grow: 0;\n  background: transparent;\n  border: none;\n  text-align: left;\n}\n\n.scl--web-component-country-select-option:hover {\n  background-color: rgba(125, 129, 135, 0.1);\n}\n\n.scl--web-component-country-select-option.selected {\n  background-color: rgba(125, 129, 135, 0.2);\n}\n\n.scl--web-component-country-select-option-flag {\n  width: 20px;\n  height: 16px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--web-component-country-select-option-flag img {\n  width: 20px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--web-component-country-select-option-label {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #7D8187;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scl--web-component-country-select-no-options {\n  padding: 12px 10px;\n  font-family: var(--primary-font);\n  font-size: 12px;\n  color: #7D8187;\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Custom scrollbar for dropdown */\n.scl--web-component-country-select-options::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scl--web-component-country-select-options::-webkit-scrollbar-track {\n  background: #393939;\n}\n\n.scl--web-component-country-select-options::-webkit-scrollbar-thumb {\n  background: #1C1C1C;\n  border-radius: 0px;\n}\n\n.scl--web-component-country-select-options::-webkit-scrollbar-thumb:hover {\n  background: #7D8187;\n}\n\n/* Error Text */\n.scl--web-component-country-select-error-text {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #FF5252;\n  padding-left: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
